import React from 'react';
import { StyledMenu, StyledMenuItem } from './styled';

const FramiMenu = ({ options, children, onClose, topComponent }) => {
    const [anchorEl, setAnchorEl] = React.useState();
    const open = !!anchorEl;

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        if (onClose) {
            onClose();
        }
        setAnchorEl(null);
    };

    return (
        <>
            {children(handleClick)}
            <StyledMenu 
                MenuListProps={{style: { paddingTop: 0, paddingBottom: 0 }}}
                anchorEl={anchorEl} 
                open={open} 
                onClose={handleClose}
            >
                {topComponent}
                {options.map((o, idx) => (
                    <StyledMenuItem
                        selected={o.selected}
                        key={idx}
                        onClick={() => {
                            handleClose();
                            o.onClick();
                        }}
                        divider={true}
                        data-cy={o.dataCy}
                    >
                        {o.text}
                    </StyledMenuItem>
                ))}
            </StyledMenu>
        </>
    );
};

export default FramiMenu;
